export default {"src":"/_next/static/media/pattern.cd618e6b.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};